import { Id } from 'app/shared/domain/value-objects/id';
import { DayOfWeek } from 'app/modules/settings/domain/valueObject/DayOfWeek';
import { LeadDays } from 'app/modules/settings/domain/valueObject/LeadDays';

export class ShipmentLeadTime {

    constructor(
        public readonly id: Id,
        public readonly dayOfWeek: DayOfWeek,
        public readonly leadDays: LeadDays,
    ) {}

}
